module.exports = __webpack_public_path__ + "static/media/view session.292910b1.svg";